/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coverfitstart2Inputs */

const en_coverfitstart2 = /** @type {(inputs: Coverfitstart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjust`)
};

const de_coverfitstart2 = /** @type {(inputs: Coverfitstart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anpassen`)
};

/**
* | output |
* | --- |
* | "Adjust" |
*
* @param {Coverfitstart2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const coverfitstart2 = /** @type {((inputs?: Coverfitstart2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coverfitstart2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coverfitstart2(inputs)
	return de_coverfitstart2(inputs)
});
export { coverfitstart2 as "coverFitStart" }